import { motion } from "framer-motion";

import { PostPreview } from "~/components/blog/post-preview";
import type { GetPosts } from "~/lib/post";
import { readingTime } from "~/lib/reading-time";

type Props = Readonly<{
  posts: GetPosts;
}>;

const container = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      ease: "easeInOut",
    },
  },
};

export function PostList({ posts }: Props): JSX.Element {
  return (
    <section className="mt-12 lg:mt-16">
      <motion.ul
        variants={container}
        initial="hidden"
        animate="visible"
        className="flex flex-col list-none m-0 p-0 gap-6 lg:gap-8"
      >
        {posts.map((p) => (
          <PostPreview
            key={p.slug}
            post={p}
            readingTime={readingTime(p.content).text}
          />
        ))}
      </motion.ul>
    </section>
  );
}
